import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../../../Layouts/Backend';
import Datagrid from '../../../../UI/Datagrid';
import { columns, defaultSorted } from './constant';
import helper from '../../../../../utils/helper';
import { Alert, Button } from '../../../../UI/Common';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import { useHistory } from 'react-router-dom';

const AssignUsersPage = (props) => {
  const { t, loading, isSubmitting, users, errors } = props;
  const history = useHistory();
  const [userIds, setUserIds] = React.useState([]);
  React.useEffect(() => {
    if (users.length) {
      const ids = users
        .filter((user) => user.isAssigned)
        .map((user) => user.userId);
      setUserIds(ids);
    }
  }, [users.length]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setUserIds([...userIds, row.userId]);
    } else {
      setUserIds(userIds.filter((x) => x !== row.userId));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.userId);
    if (isSelect) {
      setUserIds((userIds) => helper.tableHelper.selectAll(userIds, ids));
    } else {
      setUserIds((userIds) => helper.tableHelper.deselectAll(userIds, ids));
    }
  };
  const selectRow = {
    mode: 'checkbox',
    selected: userIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onAssignUsers(values);
    }
  }
  function getTitle() {
    if (props.group) {
      return `Assign Users: ${props.group.name}`;
    }
    return `Assign Users: `;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <PasswordConfirmation
          isOpen={openModal}
          onCancel={() => setOpenModal(false)}
          onConfirm={() => {
            setOpenModal(false);
            props.onAssignUsers(userIds);
          }}
        />
        <Alert.Error text={errors} />
        <Datagrid
          datagridProps={{
            keyField: 'userId',
            data: users,
            columns,
            loading,
            defaultSorted,
            selectRow,
          }}
          noExport
        />
        <div className="mt-20">
          <Button
            id="assign-users"
            classes="mr-20"
            loading={isSubmitting}
            onClick={() => onSubmit(userIds)}
          >
            <i className="md-icon">done</i>
            {t('Save')}
          </Button>
          <Button
            id="cancel-btn"
            loading={isSubmitting}
            onClick={() => history.push('/configure/groups')}
          >
            {t('Cancel')}
          </Button>
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(AssignUsersPage);
